import React from "react";
import {SvgIcon} from "@mui/material";
import type {SvgIconProps} from "@mui/material";

// Vendored Apache-2.0 Material Symbol paths use a nonstandard viewBox.
const SYMBOL_VIEW_BOX = "0 -960 960 960";

const createMaterialSymbol = (path: string, displayName: string) => {
    const MaterialSymbol = (props: SvgIconProps) => (
        <SvgIcon {...props} viewBox={SYMBOL_VIEW_BOX}>
            <path d={path}/>
        </SvgIcon>
    );

    MaterialSymbol.displayName = displayName;

    return MaterialSymbol;
};

export const AddRowAboveIcon = createMaterialSymbol(
    "M200-160h560v-240H200v240Zm640 80H120v-720h160v80h-80v240h560v-240h-80v-80h160v720ZM480-480Zm0 80v-80 80Zm0 0Zm-40-240v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80Z",
    "AddRowAboveIcon",
);

export const AddRowBelowIcon = createMaterialSymbol(
    "M200-560h560v-240H200v240Zm-80 400v-720h720v720H680v-80h80v-240H200v240h80v80H120Zm360-320Zm0-80v80-80Zm0 0ZM440-80v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80Z",
    "AddRowBelowIcon",
);

export const AddColumnLeftIcon = createMaterialSymbol(
    "M800-200v-560H560v560h240Zm-640 80v-160h80v80h240v-560H240v80h-80v-160h720v720H160Zm320-360Zm80 0h-80 80Zm0 0ZM160-360v-80H80v-80h80v-80h80v80h80v80h-80v80h-80Z",
    "AddColumnLeftIcon",
);

export const AddColumnRightIcon = createMaterialSymbol(
    "M160-760v560h240v-560H160ZM80-120v-720h720v160h-80v-80H480v560h240v-80h80v160H80Zm400-360Zm-80 0h80-80Zm0 0Zm320 120v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80Z",
    "AddColumnRightIcon",
);
